import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Badge } from '../../components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../components/ui/tooltip';

const UiPreview = () => {
  return (
    <TooltipProvider>
      <div className="mx-auto max-w-6xl space-y-6 p-6">
        <header className="space-y-1">
          <h1 className="text-2xl font-semibold">UI Preview</h1>
          <p className="text-sm text-muted-foreground">
            Screenshot-Route fuer visuelle Regression von Kernkomponenten.
          </p>
        </header>

        <Card>
          <CardHeader>
            <CardTitle>Controls</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
              <Input placeholder="Standard Input" />
              <Input state="invalid" placeholder="Invalid Input" />
              <Input state="success" placeholder="Success Input" />
            </div>
            <Textarea placeholder="Textarea" />
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <Select defaultValue="verwaltung">
                <SelectTrigger>
                  <SelectValue placeholder="Rolle" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="admin">Admin</SelectItem>
                  <SelectItem value="verwaltung">Verwaltung</SelectItem>
                  <SelectItem value="lehrer">Lehrer</SelectItem>
                </SelectContent>
              </Select>
              <div className="flex items-center gap-2">
                <Button>Primary</Button>
                <Button variant="outline">Outline</Button>
                <Button variant="destructive">Delete</Button>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Table + Badge</CardTitle>
          </CardHeader>
          <CardContent>
            <Table density="compact">
              <TableHeader>
                <TableRow>
                  <TableHead density="compact">Name</TableHead>
                  <TableHead density="compact">Rolle</TableHead>
                  <TableHead density="compact">Status</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                <TableRow>
                  <TableCell density="compact">Max Muster</TableCell>
                  <TableCell density="compact">
                    <Badge size="sm" variant="secondary">Verwaltung</Badge>
                  </TableCell>
                  <TableCell density="compact">
                    <Badge size="sm" variant="success">Aktiv</Badge>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell density="compact">Anna Beispiel</TableCell>
                  <TableCell density="compact">
                    <Badge size="sm" variant="info">Lehrer</Badge>
                  </TableCell>
                  <TableCell density="compact">
                    <Badge size="sm" variant="warning">Ausstehend</Badge>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Tabs + Tooltip</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <Tabs defaultValue="one">
              <TabsList>
                <TabsTrigger value="one">Allgemein</TabsTrigger>
                <TabsTrigger value="two">Details</TabsTrigger>
              </TabsList>
              <TabsContent value="one">Inhalt fuer Tab Allgemein</TabsContent>
              <TabsContent value="two">Inhalt fuer Tab Details</TabsContent>
            </Tabs>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button variant="secondary">Tooltip Trigger</Button>
              </TooltipTrigger>
              <TooltipContent>Kurzer Tooltip fuer Snapshot-Pruefung.</TooltipContent>
            </Tooltip>
          </CardContent>
        </Card>
      </div>
    </TooltipProvider>
  );
};

export default UiPreview;
